import { render, staticRenderFns } from "./pointConsme.vue?vue&type=template&id=89b3fbd8&scoped=true"
import script from "./pointConsme.vue?vue&type=script&lang=js"
export * from "./pointConsme.vue?vue&type=script&lang=js"
import style0 from "./pointConsme.vue?vue&type=style&index=0&id=89b3fbd8&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "89b3fbd8",
  null
  
)

export default component.exports